import React, { useState, useEffect } from 'react';
import CmsMenu from './CmsMenu';
import { Outlet } from "react-router-dom";
import './CmsLayout.scss'
import { Sidebar, Menu, Icon } from 'semantic-ui-react';
import CmsHeader from './CmsHeader';

const CmsLayout: React.FC = () => {
    const [collapsed, setCollapsed] = useState(false);
    useEffect(() => {
        const saved = localStorage.getItem('cmsSidebar');
        if (saved === 'true') setCollapsed(true);
    }, []);
    useEffect(() => {
        localStorage.setItem('cmsSidebar', collapsed.toString());
    }, [collapsed]);

    return (
        <Sidebar.Pushable>
            <Sidebar as={Menu} animation="overlay" inverted vertical visible className={collapsed ? 'collapsed' : ''}>
                <Menu.Item onClick={() => setCollapsed(!collapsed)}>
                    <Icon name="bars" color='grey' />
                </Menu.Item>
                <CmsMenu collapsed={collapsed} />
            </Sidebar>
            <Sidebar.Pusher className={collapsed ? 'collapsed' : ''}>
                <CmsHeader />
                <Outlet />
            </Sidebar.Pusher>
        </Sidebar.Pushable>
    );

}

export default CmsLayout;